import React, { Component } from 'react';
import gb from "../assets/images/gb.gif";
import pscroll from "../assets/images/scroll.gif";
import mb2v from "../assets/images/mb2v.png";
import mb2q from "../assets/images/mb2q.png";
import mb2 from "../assets/images/mb2.png";
import front from "../assets/images/front.png";

class Product extends Component {
  render() {
    return (


    			<section className="product">
    				 <div className="width-100">
       <img src={gb} className="img-responsive" alt="Website Designing" />
         </div>
  <img src={pscroll} className="scroll-pos hidden-xs hidden-sm " alt="Development Company"/>

   <div className="container">


 <div className="row">
          <div className="pagination-centered text-center">
           <div className="col-md-12 add-m-top-30">
            <h2>Looking for a Perfect Application for your Business?</h2>
            <h3>You stumbled to the right place!</h3>

            <p><a className="seo-link" href="http://garymarkinfotech.com"><b>Garymark Infotech</b></a> is a multifaceted <b>web technology</b> agency located in Ernakulum. We focus on effective and futuristic <b>web designs</b> and allied services that may equip your business or personal needs with professionalism, moral values, and utmost priority. The quality of our work will ensure and enable the clients to grab spotless reputation and best of their deals. Our team follows the customers to lend our fruitful service round the clock. We bring technology and people near to you. We move along with time to take you for a voyage with us to success.</p>
           
            </div>
          </div>
        </div>



        <div className="starting">
                <div className="row">
                   <div className="pagination-centered text-center">
                    <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12">
                        <h2 className="animation-box wow bounceIn animated"><strong className="strong">Trip Maker</strong><br/>
                           </h2>
                            <p className="c-b">Please Claim your free trial now</p>
                            </div>
                    </div>
                        <div className="login-form">
                           
                         
                            <a href="http://upgrade3.garysoft.in/login" className="btn btn-download wow animated fadeInLeft">
                            <i className="fa fa-user-secret pull-left"></i>
                            <strong>Register </strong>
                            <br/>Here </a>
                            <a href="http://upgrade3.garysoft.in/login" className="btn btn-download wow animated fadeInRight">
                            <i className="fa fa-user pull-left"></i>
                            <strong>Login </strong>
                            <br/>Here </a>   
                        </div>
                    </div>
                    </div>
                </div>
       </div>



           <section id="features" className="wrapper features">
        <div className="container">
          <div className="row">
              <div className="pagination-centered text-center">
                <div className="col-md-12 col-sm-12 wow animated fadeInRight">
                    <img src={mb2q} alt="Development Company" className="img-responsive img-inline"/>
                </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-sm-6 wow animated fadeInLeft">
                    <img src={mb2} alt="Ui Design" className="pull-right left-img"/>
                </div>
                <div className="col-md-6 col-sm-6 wow animated fadeInRight">
                    <div className="features-list">
                        <h3>KEY FEATURES</h3>
                        <p>
                            Your project looks great on any device. Content can be easily read and a user understands freely what you wanted.
                        </p>
                        <ul className="right">
                            <li className="li"><i className="fa fa-chevron-right"></i> Fast and Easy to Create enquires</li>
                            <li className="li"><i className="fa fa-chevron-right"></i> Automated Customer Email with fully loaded itinerary</li>
                            <li className="li"><i className="fa fa-chevron-right"></i> Automated Enquiry comparison from last Month</li>
                            <li className="li"><i className="fa fa-chevron-right"></i> Enquiry conversation for staff</li>
                            <li className="li"><i className="fa fa-chevron-right"></i> Completed Enquiry status</li>
                            <li className="li"><i className="fa fa-chevron-right"></i> Different kind of enquiry reports</li>
                            <li className="li"><i className="fa fa-chevron-right"></i> Cancelled enquiry with specific reasons</li>
                            <li className="li"><i className="fa fa-chevron-right"></i> ISO Levels</li>
                        </ul>
                    </div> 
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-sm-6 wow animated fadeInLeft">
                    <div className="features-list-left">
                        <h3>IN BUILT FEATURES</h3>
                        <p>
                            Your project looks great on any device. Content can be easily read and a user understands freely what you wanted.
                        </p>
                        <ul className="left hidden-xs hidden-sm">
                            <li className="li">Convert the enquiry to booking in seconds<i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated booking compression from last month <i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated customer confirmation email<i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated Hotel Vouchers <i className="fa fa-chevron-left"></i></li>
                            <li className="li">One Click to send hotel reservation<i className="fa fa-chevron-left"></i></li>
                            <li className="li">One click to send transport booking <i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated Invoice <i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated In Tour Details <i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated Invoice <i className="fa fa-chevron-left"></i></li>
                            <li className="li">On date arrival details<i className="fa fa-chevron-left"></i></li>
                            <li className="li">On date departure details <i className="fa fa-chevron-left"></i></li>
                            <li className="li">Upcoming arrival details<i className="fa fa-chevron-left"></i></li>
                        </ul>
                        <ul className="left hidden-md hidden-lg">
                              <li className="li">Convert the enquiry to booking in seconds<i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated booking compression from last month <i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated customer confirmation email<i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated Hotel Vouchers <i className="fa fa-chevron-left"></i></li>
                            <li className="li">One Click to send hotel reservation<i className="fa fa-chevron-left"></i></li>
                            <li className="li">One click to send transport booking <i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated Invoice <i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated In Tour Details <i className="fa fa-chevron-left"></i></li>
                            <li className="li">Automated Invoice <i className="fa fa-chevron-left"></i></li>
                            <li className="li">On date arrival details<i className="fa fa-chevron-left"></i></li>
                            <li className="li">On date departure details <i className="fa fa-chevron-left"></i></li>
                            <li className="li">Upcoming arrival details<i className="fa fa-chevron-left"></i></li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-6 col-sm-6 wow animated fadeInRight">
                    <img src={mb2v} alt="Ui Design" className="pull-left right-img add-m-top-70"/>
                </div>
            </div> 
    

     

             <div className="row">
                <div className="col-sm-4">
                    <ul className="suite">
                        <li className="wow fadeInLeft animated"> <i className="fa fa-film"></i> 
                            <h3>Responsive design</h3>
                            <p>Your project looks great on any device. Content can be easily read and a user understands freely what you wanted.</p>
                        </li>
                        <li className="wow fadeInLeft animated"> <i className="fa fa-bolt"></i> 
                            <h3>Vibrant Flat Design</h3>
                            <p>The set of ready made CSS files with different color schemes will help you in quick landing’s adaptation according to your benchmark style.</p>
                        </li>
                        <li className="wow fadeInLeft animated"> <i className="fa fa-heart"></i> 
                            <h3>Highly Secured </h3>
                            <p>The graphic source file in PSD format is included in the archive.</p>
                        </li>
                    </ul>
                </div>
                <div className="col-sm-4 col-sm-push-4">
                    <ul className="suite">
                        <li className="wow fadeInRight animated"> <i className="fa fa-life-ring"></i>
                            <h3>Well Documentation</h3>
                            <p>We have well documented moduler codes. Meaningfull Comments in code will help you to customize it easily.</p>
                        </li>
                        <li className="wow fadeInRight animated"> <i className="fa fa-lock"></i>
                            <h3>Easily Customizable</h3>
                            <p>It is easy to customize. No heavy coding is required to customize it with your real contents.</p>
                        </li>
                        <li className="wow fadeInRight animated"> <i className="fa fa-star"></i>
                            <h3>Future Support</h3>
                            <p>We will update and fix bugs if you found one for a long time.</p>
                        </li>
                    </ul>
                </div>
                <div className="col-sm-4 col-sm-pull-4 text-center">
                    <div className="animation-box wow bounceIn animated">
                        
                        <img className="screen img-responsive" src={front} alt="garymark infotech" />
                    </div>
                </div>
            </div>
       </div>
    </section>







   </div>

    			</section>
    	 );
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/pages/product.js